import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../src/environments/environment';
import { take, takeUntil, first } from 'rxjs/operators';
import { ErrorStreamChange } from 'src/app/models/$error.model';
import {  filterPageTypes,  FilterCountChanges, FilterGroup, filterActions } from 'src/app/store/filters.era';
import { FilterDialogComponentParams } from '../filters/filters-ui.models';
import { FiltersDialogComponent } from '../filters/filters-dialog.component';
import { timelineParents } from 'src/app/helpers/helpers';
import { filterSnapshotTimelines } from 'src/app/store/reselectors/filteredPrograms.reselector';
import { JoiEvent } from 'src/app/store/events.era';
import { cacheActions } from 'src/app/store/cache.era';
import { performerDisplayTypes } from 'src/app/store/performers.era';
import { ProgramTimelineMultiColumnProgram, ProgramTimelineSnapshot } from 'globals/store/programs.data';
import { Wrapper } from '../wrapper.component';
import { IconComponent } from '../icon/icon.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { flatten, makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { TimelineComponent } from './timeline.component';

@Component({
    selector: 'snapshot-dialog',
    template: `
<div class="snapshot-dialog">
    <div class="header_bar">
        <div *ngIf="event" class="select_items">
            <div class="label">Snapshots: </div>
            <mat-select (selectionChange)="loadSnapshot($event)" [ngModel]="snapshotId">
                <mat-option *ngFor="let shot of event.snapshots" [value]="shot.id">
                    {{shot.name}}
                </mat-option>
            </mat-select>
        </div>
        <div class="util_items">
            <div class="control" (click)="doFilter()" [ngClass]="{active: !!activeFilterCount}"><icon icon="filter_24px"></icon></div>
            <div class="control" (click)="doPrint()"><icon matIcon="print"></icon></div>
            <div class="control" (click)="dialogRef.close()"><icon matIcon="close"></icon></div>
        </div>
    </div>
    <div class="snapshot_content">
        <event-timeline #timeline *ngIf="!!snapshot_data" [performerDisplayType]="performerDisplayType" [staticPerformerData]="snapshot_data.performerData" [parent]="timelineParent" [data]="filteredData" (filter)="doFilter()"></event-timeline>
    </div>
</div>
    `,
    styleUrls: ['./timeline.component.scss', './snapshot.scss'],
    standalone: true,
    imports: [IconComponent, TimelineComponent, MatSelectModule, FormsModule, CommonModule],
})
export class SnapshotDialogComponent extends Wrapper<SnapshotDialogComponent> implements OnInit {

  readonly api = `${environment.functionsURL}api/app`;
  snapshotId: string;
  snapshot_data: ProgramTimelineSnapshot = null;
  snapshotPrograms: ProgramTimelineMultiColumnProgram[] = []
  public filteredData: ProgramTimelineSnapshot
  event: JoiEvent
  snapshotFetchers: any = {}
  snapshotEntities: any = {}
  timelineParent = timelineParents.snapshot
  performerDisplayType = performerDisplayTypes.snapshot
  filters: FilterGroup

  public activeFilterCount: number

  constructor(public dialogRef: MatDialogRef<SnapshotDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: SnapshotDialogData) {
    super()
    // console.log('data', data, event.snapshot_cache);
    // this.snapshot_data = data;
    const { snapshotId } = data
    this.snapshotId = snapshotId
    // TODO: (optional) unravel this ugly async update logic
    this.loadSnapshot({ value: this.snapshotId })

    this.subCallback(this.store.select('events', 'event'), event => {
      this.event = event
      this.loadSnapshot({ value: this.snapshotId })
    })

    this.subCallback(this.store.select('cache', 'snapshots', 'entities'), snapshotEntities => {
      this.snapshotEntities = snapshotEntities
      this.loadSnapshot({ value: this.snapshotId })
    })

    this.subProp(this.store.select('filters', filterPageTypes.programTimelineSnapshot, 'count'), 'activeFilterCount')
    this.subCallback(this.store.select('filters', filterPageTypes.programTimelineSnapshot), filters => {
      this.filters = filters
      this.filter()
    })
  }

  loadSnapshot(ev) {
    if (!this.snapshotEntities) {
      // console.log('snapshot entities not loaded yet')
      return
    }
    this.snapshotId = ev.value;
    const snapshot = this.snapshotEntities[this.snapshotId]
    if (snapshot) {
      this.snapshot_data = snapshot
      console.log( { snapshot })
      this.loadFilterData()
      this.filter()
      this.data.setClassSnapshotOpenInTimeline(true)
    } else {
      // keeping the action to get the snapshot in this component assumes that nothing else will be updating the snapshot entities and causing an infinite loop
      this.downloadSnapshot(this.snapshotId)
    }
  }

  filter() {
    if (this.snapshot_data && this.filters) {
      const { single_column, multiple_column } = filterSnapshotTimelines(this.snapshot_data.columns, this.filters)
      this.filteredData = { ...this.snapshot_data, columns: { single_column, multiple_column } }
    }
  }

  downloadSnapshot(snapshotId: string) {
    if (!this.event) {
      console.log('Event not loaded yet...')
      return
    }
    const url = `${this.api}/load-snapshot`
    // console.log({ url })
    const filePath = `snapshots/${this.event.eventId}/${snapshotId}`
    this.http.post(url, { filePath }).pipe(take(1)).subscribe(data => {
      const shot = this.event.snapshots.find(sh => sh.id === snapshotId)
      const snapshot_obj = { ...shot, ...data }
      // console.log({ snapshot_obj })
      this.store.dispatch(cacheActions.cacheEventSnapshot(snapshot_obj)) // loading will go back through load snapshot when store is updated
    }, (response) => {
      // console.log(response);
      this.logService.error({
        file: 'snapshot.dialog',
        error: new Error(), function: 'downloadSnapshot() /load-snapshot',
        data: { filePath }, message: 'Error change snapshot'
      } as ErrorStreamChange)
    });

  }

  ngOnInit() { }

  loadFilterData() {
    if (!this.snapshot_data) {
      // console.log('Snapshot data not loaded yet!')
      return
    }
    const { template, columns, performerData } = this.snapshot_data
    this.snapshotPrograms = flatten(columns.multiple_column.map(c => c.programs))
    const program_legend: { [pId: string]: ProgramTimelineMultiColumnProgram } = {}

    this.snapshotPrograms.forEach(p => program_legend[p.pID] = p)
    this.snapshot_data.program_legend = program_legend

    // console.log({ snapshotData: this.snapshot_data })
    const { program, session, workersByEmail } = template // program labels and session labels
    const programLabels = makeMapFromListOfObjectsAndKey(program, 'id')
    const sessionLabels = makeMapFromListOfObjectsAndKey(session, 'id')

    const performers = performerData ? performerData.performers : {}


    this.snapshotFetchers = {
      programFetcher: (id) => program_legend[id],
      programLabelFetcher: (id) => programLabels[id],
      sessionLabelFetcher: (id) => sessionLabels[id],
      workersByEmail,
      performers
    }
    const { timelineFilters: filters, tempTimelineFilterCount } = this.snapshot_data
    const filterGroup = filterPageTypes.programTimelineSnapshot
    this.filteredData = this.snapshot_data
    if (!filters) { // old data, not applying filters upon load of old data
      this.store.dispatch(filterActions.changeFilterCount({ filterGroup, changeType: FilterCountChanges.Reset }))
      this.store.dispatch(filterActions.clearFilterGroup(filterGroup))

    } else {
      this.store.dispatch( filterActions.changeFilterCount({ filterGroup, changeType: FilterCountChanges.Set, value: tempTimelineFilterCount }))
      this.store.dispatch(filterActions.updateFilters({ filterGroup, filters }))
    }
  }

  doFilter() {
    this.filtersService.buildProgramTimelineFilterUI(null, this.snapshotFetchers, this.snapshotPrograms).then(filterGroupings => {
      const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.programTimelineSnapshot, filterGroupings } }
      const d = this.dialog.open(FiltersDialogComponent, params);
    })
  }
  doPrint() {
    this.uiService.print();
  }

}

export interface SnapshotDialogData { 
  snapshotId: string
  setClassSnapshotOpenInTimeline: Function 
}